"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostHogNextProvider = void 0;
const react_1 = __importDefault(require("react"));
const TrackNextRouter_1 = __importDefault(require("./TrackNextRouter"));
const ErrorBoundary_1 = require("./ErrorBoundary");
const lib_1 = require("../lib");
const PostHogNextProvider = ({ apiKey, projectId, enable, config, trackNextRouterChanges = true, reportWebVitals, enableErrorBoundary = true, errorComponent, children }) => {
    return (react_1.default.createElement(lib_1.PostHogProvider, { apiKey: apiKey, projectId: projectId, enable: enable, config: config, reportWebVitals: reportWebVitals },
        trackNextRouterChanges && react_1.default.createElement(TrackNextRouter_1.default, null),
        react_1.default.createElement(react_1.default.Fragment, null, enableErrorBoundary ? (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { errorComponent: errorComponent }, children)) : ({ children }))));
};
exports.PostHogNextProvider = PostHogNextProvider;
exports.default = exports.PostHogNextProvider;
